import Vue from 'vue'

const state = {
    allRoutes: null,
    isLoadingRoutes: false,
    allLocations: null,
    isLoadingLocations: false,
};

const getters = {
    getAllRoutes: (state) => state.allRoutes,
    getIsLoadingRoutes: (state) => state.isLoadingRoutes,
    getAllLocations: (state) => state.allLocations
};

const actions = {
    downloadRoutes ({state, rootState, commit}){
        if(!rootState.user.account.supplierId){
            return false
        }

        state.isLoadingRoutes = true
        return axios.get('/api/reservation/GetAllRoutes', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isLoadingRoutes = false
            if (response && response.status === 200 && response.data && response.data.length > 0) {
                commit('SET_ALLROUTES', response.data)
            } else {
                commit('SET_ALLROUTES', [])
            }
        }).catch(err => {
            state.isLoadingRoutes = false
        })
    },

    downloadLocations ({state, rootState, commit}) {
        state.isLoadingLocations = true
        return axios.get('/api/supplier/locations', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isLoadingLocations = false
            if(response.status == 200){
                commit('SET_ALLLOCATIONS', response.data)
            }
        }).catch(err => {
            state.isLoadingLocations = false
        })
    },

    addTransportLocation ({state, commit}, location) {
        commit('ADD_LOCATION', location)
    },

    removeTransportLocation ({state, commit}, location) {
        commit('REMOVE_LOCATION', location)
    }
};

const mutations = {
    SET_ALLROUTES: (state, payload) => {
        state.allRoutes = payload;
    },

    SET_ALLLOCATIONS: (state, payload) => {
        state.allLocations = payload
    },

    ADD_LOCATION: (state, location) => {
        state.allLocations.push(location)
    },

    REMOVE_LOCATION: (state, location) => {
        state.allLocations.splice(state.allLocations.indexOf(location), 1)
    }

};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transportation.js